module.exports = __webpack_public_path__ + "img/venezuela.8198e6ee.svg";